import React from 'react';
import StrategyProfileLayout from '../StrategyProfileLayout';
const TargetView = () => {
  return (
    <StrategyProfileLayout>
      <div></div>
    </StrategyProfileLayout>
  );
};

export default TargetView;
